import { PointData } from 'pixi.js';
import { Util } from './util';

export class Scribble {
    public static polygon(points: PointData[], amplitude: number = 2) {
        if (points.length < 1) return [];
        if (amplitude == 0) return [];

        let first = points.shift() as PointData;
        let polygonScribbles: PointData[] = [first];
        for (let current of points) {
            let previous = polygonScribbles[polygonScribbles.length - 1];
            let lineScribbles = Scribble.line(previous, current, amplitude);
            /* Throw out the first point each time, it will be a repeat because lines connect */
            lineScribbles.shift();
            polygonScribbles.push(...lineScribbles);
        }
        return polygonScribbles;
    }

    private static line(a: PointData, b: PointData, amplitude: number) {
        let noiseRate = 1 / 30;
        let minSegmentLength = 4, maxSegmentLength = 12;
        let getRandomSegment = () => Util.randBetween(minSegmentLength, maxSegmentLength);
        let getNoise = () => Util.randBetween(0, 1);

        let vector = { x: b.x - a.x, y: b.y - a.y };
        let distance = Math.sqrt(vector.x * vector.x + vector.y * vector.y);

        const scribblePoints = [{ x: a.x, y: a.y }];

        let lastPoint = { x: a.x, y: a.y };
        let noise1 = getNoise(), noise2 = getNoise();

        for (let segment = getRandomSegment(), i = 0, walk = 0; segment < distance - maxSegmentLength; segment += getRandomSegment(), i++) {
            let point = { x: a.x + (vector.x / distance) * segment, y: a.y + (vector.y / distance * segment) };
            let handVector = { x: lastPoint.x, y: lastPoint.y };
            handVector.x = handVector.x - point.x;
            handVector.y = handVector.y - point.y;
            let length = Math.sqrt(handVector.x * handVector.x + handVector.y * handVector.y);
            walk += (length * noiseRate);
            if (walk >= 1) {
                noise1 = noise2;
                noise2 = getNoise();
                walk--;
            }
            let sigmoid = walk * walk * (3 - 2 * walk);
            let randomLength = (noise1 * (1 - sigmoid) + noise2 * sigmoid) * amplitude;

            let c = { x: handVector.y, y: handVector.x };
            c.x /= Math.sqrt(c.x * c.x + c.y * c.y);
            c.y /= Math.sqrt(c.x * c.x + c.y * c.y);
            c.x *= -randomLength;
            c.y *= randomLength;

            scribblePoints.push({ x: point.x + c.x, y: point.y + c.y });
            lastPoint = { x: point.x, y: point.y };
        }

        scribblePoints.push({ x: b.x, y: b.y });
        return scribblePoints;
    }
}
